
<!--亲子游课后服务设置-->
<template>
  <div class="app-container">
    <el-tabs type="card" v-model="servcieSetingType" @tab-click="handleClickType">
      <el-tab-pane label="亲子课评设置" name="1">
        <service-interactive-content ref="SW_INTERACTIVE_CONTENT"></service-interactive-content>
      </el-tab-pane>
      <el-tab-pane label="基础课评设置" name="2">
        <service-interactive-content-bs ref="SW_INTERACTIVE_CONTENT_BS"></service-interactive-content-bs>
      </el-tab-pane>
      <el-tab-pane label="通用课评设置" name="3">
        <service-sw-statu ref="SW_STATU" ></service-sw-statu>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<style scoped>
  /deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav {
    border: none;
  }
  /deep/ .el-tabs__item{
    height: 36px;
    color: #0e6eba;
    background: #cedef5;
    margin-right: 10px;
    border-radius: 4px;
    line-height: 36px;
    /* 卡片阴影 */
    box-shadow: 0px 0px 16px 4px rgba(238, 56, 35, 0.09);
  }
  /deep/ .el-tabs__item.is-active{
    color: #ffffff;
    text-align: center;
    background: linear-gradient(120.93deg, #1270b8 3.98%, #5aaeee 100%);
  }
  /deep/ .el-tabs__active-bar{
    display: none;
  }
  /deep/ .el-tabs__nav-wrap::after{
    display: none;
  }
  .top-row{
    width: 40%;
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    text-align: center;
  }
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>
<script>
  import ServiceInteractiveContent from "./components/ServiceInteractiveContent";
  import ServiceInteractiveContentBs from "./components/ServiceInteractiveContentBs";
  import ServiceSwStatu from "./components/ServiceSwStatu";

  export default {
    components: {
      ServiceInteractiveContent,
      ServiceInteractiveContentBs,
      ServiceSwStatu,
    },
    data() {
      return {
        servcieSetingType:"1"
      }
    },
    created() {

    },
    mounted(){

    },
    methods: {
      handleClick(){
        let ref = this.activeName;
        if (ref == 1){

        } else if (ref == 2) {
          this.$refs["SW_KIKING"].reloadData();
        }else if (ref == 3) {
          console.log("handleClick",ref)
          this.$refs["SW_BREATE"].reloadData();
        }else if (ref == 4) {

          this.$refs["SW_HANDMOVE"].reloadData();
        }else if (ref == 5) {

          this.$refs["SW_HELPSELF"].reloadData();
        }else if (ref == 6) {

          this.$refs["SW_SPEED"].reloadData();
        }else {
          console.log("handleClick wu",ref)
        }


      },

      handleClickType(){
        let ref = this.servcieSetingType;
        if (ref == 2){
          this.$refs["SW_INTERACTIVE_CONTENT_BS"].reloadData();
        }else if (ref ==3){
          this.$refs["SW_STATU"].reloadData();
        }
      }
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/store-setting/after-service-cf/index.vue